<template>
  <div class="forgotPasswordForm">
    <div v-if="!success">
      <h2>Forgot Password</h2>
      <el-alert
        class="errorMessage"
        :title="error"
        type="error"
        v-show="error"
        :closable="false">
      </el-alert>
      <form @submit="submit">
        <el-input placeholder="Enter email" v-model="email" class="email"></el-input>
        <el-button type="primary" class="loginButton" @click="submit">Send Reset Link</el-button>
      </form>
    </div>
    <div v-else>
      <p align="center">Check your inbox for a link to reset your&nbsp;password.</p>
    </div>
  </div>
</template>

<script>
  import ApiClient from '@/components/api-client'

  export default {
    name: 'request-password-reset',
    data () {
      return {
        email: null,
        error: '',
        success: false
      }
    },
    methods: {
      submit (e) {
        e.preventDefault()
        if (!this.email) {
          this.error = 'Email is required'
        } else if (!this.validEmail(this.email)) {
          this.error = 'Invalid email address'
        }

        if (this.error !== '') {
          return
        }
        ApiClient.forgotPassword({email: this.email})
          .then(() => {
            this.success = true
          })
      },
      validEmail (email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line no-useless-escape
        return re.test(email)
      }
    },
    watch: {
      email (newValue, oldValue) {
        if ((oldValue === '' || !this.validEmail(oldValue)) && newValue !== '') {
          this.error = ''
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .forgotPasswordForm {
    box-sizing: border-box;
    width: 420px;
    padding: 25px 30px 25px 30px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.14);
    h2 {
      font-weight: normal;
      color: #898989;
      margin: 0;
    }
    p {
      margin: 0;
    }
    button {
      float: right;
    }
    .email {
      margin: 15px 0;
    }

  }
</style>
